import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Label from 'zignal-landscape/lib/Label';
import concat from 'lodash/concat';
import without from 'lodash/without';
import map from 'lodash/map';
import includes from 'lodash/includes';
import styles from './CheckboxSelect.css';

class CheckboxSelect extends React.Component {

  constructor(props) {
    super(props);
    this.handleCheckboxChanged = this.handleCheckboxChanged.bind(this);
    this.handleAllCheckboxChanged = this.handleAllCheckboxChanged.bind(this);
    this.handleSoloSelect = this.handleSoloSelect.bind(this);
  }

  handleCheckboxChanged(e) {
    const { onChange, value } = this.props;
    const input = e.currentTarget;
    let newValue = value;
    if (input.checked) {
      newValue = concat(value, input.value);
    } else {
      newValue = without(value, input.value);
    }
    onChange(newValue);
  }

  handleAllCheckboxChanged(e) {
    const { onChange, options } = this.props;
    const input = e.currentTarget;
    onChange(input.checked ? map(options, 'value') : []);
  }

  handleSoloSelect(e) {
    const { onChange } = this.props;
    const parent = e.currentTarget.parentNode;
    const input = parent.querySelector('input');
    onChange([input.value]);
  }

  render() {
    const { options, value } = this.props;

    if (options.length === 0 ) {
      return null;
    }

    const optionItems = options.map((option) => {
      const checked = includes(value, option.value);
      return (
        <div data-cy="checkbox-select" className={styles.Checkbox} key={option.value}>
          <Checkbox
            id={`CheckboxSelect_${option.value}`}
            value={option.value}
            name={`CheckboxSelect_${option.value}`}
            checked={checked && option.supportsHistorics}
            onChange={this.handleCheckboxChanged}
            disabled={option.supportsHistorics === false}
          />
          <Label
            disabled={option.supportsHistorics === false}
            inline
            htmlFor={`CheckboxSelect_${option.value}`}
            data-cy="checkbox-select-label"
          >
            {option.label}
          </Label>
          <span className={styles.soloSelect} onClick={this.handleSoloSelect}>Only</span>
        </div>
      );
    });

    return (
      <div className={styles.CheckboxSelect}>
        <Checkbox
          id="CheckboxSelect_all"
          name="CheckboxSelect_all"
          checked={value.length === options.length}
          onChange={this.handleAllCheckboxChanged}
        />
        <Label inline htmlFor="CheckboxSelect_all"> All</Label>
        <div className={styles.OptionList}>
          {optionItems}
        </div>
      </div>
    );
  }
}

CheckboxSelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func
};

CheckboxSelect.defaultProps = {
  options: [],
  value: []
};

export default CheckboxSelect;
